import * as React from "react";

/**
 * No-op shim for `react-helmet-async`.
 *
 * The Valentine Digital `dynamic_optimization.js` script is the SOLE
 * authority for route-level SEO (title, description, canonical, OG,
 * Twitter, JSON-LD). This shim is aliased over `react-helmet-async`
 * in vite.config.ts so every existing `<Helmet>…</Helmet>` block in
 * the codebase becomes a no-op without having to edit hundreds of
 * page files. `<HelmetProvider>` is a passthrough.
 *
 * If you need to set a meta tag from React code, set it directly on
 * `document.head` inside a `useEffect` — do NOT use Helmet.
 */

export const Helmet: React.FC<{ children?: React.ReactNode }> = () => null;

export const HelmetProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <>{children}</>;

export default Helmet;